// extracted by mini-css-extract-plugin
export default {"headerBack":"Policy_headerBack__m2Axj","container":"Policy_container__Tru+N","btnRow":"Policy_btnRow__zdp6G","btn":"Policy_btn__GwTYF","textDiv":"Policy_textDiv__sOPvP"};